import { makeAutoObservable, runInAction } from 'mobx'
import agent from '../api/agent'
import { HomeFilter } from '../models/Filter'
import { HomeFilterMode } from '../models/modes'

export default class HomeFilterStore {
  filterResult: object[] = []

  show: boolean = false

  loading = false

  search = {
    propertyType: HomeFilterMode.All,
    propertyForm: 'all',
    city: '',
    priceFrom: 0,
    priceTo: 0,
    metersFrom: 0,
    metersTo: 0,
  }

  constructor() {
    makeAutoObservable(this)
  }

  setShow = (state: boolean) => {
    this.show = state
  }

  setSearch = (state: HomeFilter) => {
    this.search = state
  }

  listHomeFilter = async (filter: HomeFilter) => {
    this.loading = true
    const { status, data: result } = await agent.HomeFiltering.list(filter)

    if (status === 200) {
      runInAction(() => {
        this.filterResult = result
        this.loading = false
      })
    }
  }
}
